import React, { useState, useEffect } from "react";
import {
	Box,
	Typography,
	Paper,
	Tabs,
	Tab,
	Button,
	CircularProgress,
} from "@mui/material";
import { Send, Bell } from "lucide-react"; // Add Bell icon
import { useNavigate } from "react-router-dom"; // Add this import
import DelayedSchoolVisits from "../../components/notifications/DelayedSchoolVisits";
import SendNotificationModal from "../../components/notifications/SendNotificationModal";
import { useAuth } from "../../contexts/AuthContext";

const Notifications = () => {
	const { user, supabase } = useAuth();
	const navigate = useNavigate(); // Add this
	const [currentTab, setCurrentTab] = useState(0);
	const [openSendModal, setOpenSendModal] = useState(false);
	const [userProfile, setUserProfile] = useState(null);
	const [loading, setLoading] = useState(true);

	useEffect(() => {
		fetchUserProfile();
	}, [user.id]);

	const fetchUserProfile = async () => {
		try {
			setLoading(true);
			const { data, error } = await supabase
				.from("profiles")
				.select("id, role, status, full_name, email")
				.eq("id", user.id)
				.single();

			if (error) throw error;
			setUserProfile(data);
		} catch (err) {
			console.error("Error fetching user profile:", err);
		} finally {
			setLoading(false);
		}
	};

	const handleTabChange = (event, newValue) => {
		setCurrentTab(newValue);
	};

	// Check if user can send notifications (admin or employee)
	const canSendNotifications = userProfile?.role === "ROLE_FUNMIYO_ADMIN";


	if (loading) {
		return (
			<Box sx={{ display: "flex", justifyContent: "center", p: 3 }}>
				<CircularProgress />
			</Box>
		);
	}

	return (
		<Box sx={{ p: 3 }}>
			<Box
				sx={{
					display: "flex",
					justifyContent: "space-between",
					alignItems: "center",
					mb: 3,
				}}>
				<Typography variant="h4" sx={{ fontWeight: "bold" }}>
					Notifications
				</Typography>

				<Box sx={{ display: "flex", gap: 2 }}>
					{/* View All Notifications Button */}
					<Button
						variant="outlined"
						startIcon={<Bell size={20} />}
						onClick={() => navigate("/all-notifications")}
						sx={{
							borderColor: "primary.main",
							color: "primary.main",
							"&:hover": {
								borderColor: "primary.dark",
								bgcolor: "primary.50",
							},
						}}>
						View All Notifications
					</Button>

					{canSendNotifications && (
						<Button
							variant="contained"
							startIcon={<Send size={20} />}
							onClick={() => setOpenSendModal(true)}
							sx={{
								bgcolor: "primary.main",
								"&:hover": {
									bgcolor: "primary.dark",
								},
							}}>
							Send Notification
						</Button>
					)}
				</Box>
			</Box>

			<Paper
				elevation={0}
				sx={{ border: "1px solid #e5e7eb", borderRadius: "8px" }}>
				<Tabs
					value={currentTab}
					onChange={handleTabChange}
					sx={{ borderBottom: "1px solid #e5e7eb", px: 2 }}>
					<Tab label="Delayed School Visits" />
					<Tab label="Other Notifications" />
				</Tabs>

				<Box sx={{ p: 3 }}>
					{currentTab === 0 && <DelayedSchoolVisits />}
					{currentTab === 1 && (
						<Typography variant="body1" color="text.secondary">
							Other notifications will be displayed here.
						</Typography>
					)}
				</Box>
			</Paper>

			{/* Send Notification Modal */}
			{userProfile && (
				<SendNotificationModal
					open={openSendModal}
					onClose={() => setOpenSendModal(false)}
					supabase={supabase}
					currentUser={userProfile}
				/>
			)}
		</Box>
	);
};

export default Notifications;
